import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Layout from "@/components/Layout";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const startGoogleAuth = () => {
  const redirectUrl = window.location.origin + "/auth/callback";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome back, ${u.name}`);
      nav(u.role === "admin" ? "/admin" : u.role === "seller" ? "/seller" : "/buyer");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Layout>
      <section className="max-w-md mx-auto px-6 py-16">
        <h1 className="heading text-4xl font-black uppercase tracking-tight">Sign in</h1>
        <p className="text-[#555] mt-2">Welcome back to Jubasmash.</p>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <label className="mono text-xs uppercase tracking-[0.2em] font-bold">Email</label>
            <input data-testid="login-email" required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full mt-2 brut-border bg-white px-4 py-3 focus:outline-none focus:ring-0 focus:border-[#C77E3C]" />
          </div>
          <div>
            <label className="mono text-xs uppercase tracking-[0.2em] font-bold">Password</label>
            <input data-testid="login-password" required type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full mt-2 brut-border bg-white px-4 py-3 focus:outline-none focus:ring-0 focus:border-[#C77E3C]" />
          </div>
          <button data-testid="login-submit-btn" disabled={busy} className="btn-primary w-full">{busy ? "Signing in…" : "Sign in"}</button>
        </form>
        <div className="mt-3 text-right">
          <Link to="/forgot-password" data-testid="forgot-link" className="mono text-xs uppercase tracking-[0.2em] text-[#C77E3C]">Forgot password?</Link>
        </div>
        <div className="mt-6 flex items-center gap-4">
          <div className="flex-1 border-t-2 border-[#1F3D2A]" />
          <div className="mono text-[10px] uppercase tracking-[0.3em] text-[#555]">or</div>
          <div className="flex-1 border-t-2 border-[#1F3D2A]" />
        </div>
        <button data-testid="google-login-btn" onClick={startGoogleAuth} className="btn-ghost w-full mt-6">Continue with Google</button>
        <p className="mt-6 mono text-xs uppercase tracking-[0.2em] text-[#555]">
          No account? <Link to="/signup" data-testid="signup-link" className="text-[#C77E3C]">Create one →</Link>
        </p>
      </section>
    </Layout>
  );
}
